module.exports = __webpack_public_path__ + "assets/img/7782-iq.svg";